export default "__VITE_ASSET__CCuLXehi__"